import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TimelineSection from "./components/TimelineSection";
import SeriesSection from "./components/SeriesSection";
import RecapSection from "./components/RecapSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import SchemaOrg from "./components/SchemaOrg";

export default function Home() {
  return (
    <>
      <SchemaOrg />
      <Navbar />
      <main>
        <Hero />
        <TimelineSection />
        <SeriesSection />
        <RecapSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}